import React from "react";
import { TextBoxWithFlag, Flag, Text } from "./TextBoxWithFlag";
import { GB } from "country-flag-icons/react/3x2";

interface TranslationProps {
  targetWord: string;
  phraseTranslation?: string;
  nativeWord: string;
  isPhraseLoading?: boolean;
  isPhraseError?: boolean;
  className?: string;
}

const Translation: React.FC<TranslationProps> = ({
  targetWord,
  phraseTranslation,
  nativeWord,
  isPhraseLoading,
  isPhraseError,
  className,
}) => {
  const highlightColorBlueAndCls =
    "bg-[var(--color-blue)] text-white rounded px-[4px] py-[3px] mt-4";

  let content;
  if (isPhraseError) {
    content = "Something went wrong, please try again.";
  } else if (isPhraseLoading) {
    content = "Translating...";
  } else if (nativeWord === "" || targetWord === "") {
    content = "Click a word to see it's translation";
  } else {
    const noPhraseTranslation = phraseTranslation === undefined;
    const highlightText = noPhraseTranslation ? `"${nativeWord}"` : "";
    const followUpText = noPhraseTranslation
      ? " - " + targetWord
      : `"${phraseTranslation}"`;
    content = (
      <>
        <span
          className={
            highlightColorBlueAndCls +
            " rounded-md" +
            (noPhraseTranslation ? "" : " hidden")
          }
        >
          {highlightText}
        </span>
        {followUpText}
      </>
    );
  }

  return (
    <TextBoxWithFlag className={className}>
      <Flag>
        <GB title="GB" className="w-8" />
      </Flag>
      <Text>{content}</Text>
    </TextBoxWithFlag>
  );
};

export default Translation;
